import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';
@Directive({
    selector: '[validatorCode][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidatorCodeDirective), multi: true }]
})
export class ValidatorCodeDirective {
    ///这是判断需要什么类型的校验
    @Input('validatorCode')
    type: any;

    constructor() { }

    validate(control: AbstractControl): { [property: string]: string } {
        // 中文
        let reg1 = /^[\u4e00-\u9fa5]{1,}$/;
        // 英文
        let reg2 = /^[a-zA-Z]{1,}$/;
        // 数字
        let reg3 = /^[0-9]{1,}$/;
        // 数字和小数点
        let reg4 = /^[0-9.]{1,}$/;
        // 数字和英文
        let reg5 = /^[0-9a-zA-Z]{1,}$/;
        // 下划线、数字和英文
        let reg6 = /^[_0-9a-zA-Z]{1,}$/;
        // 下划线和英文
        let reg7 = /^[_a-zA-Z]{1,}$/;
        // /和中文
        let reg8 = /^[a-zA-Z\u4e00-\u9fa5\/]{1,}$/;
        // 中文和英文
        let reg9 = /^[a-zA-Z\u4e00-\u9fa5]{1,}$/;
        // 中文和英文()
        let reg10 = /^[()a-zA-Z\u4e00-\u9fa5]{1,}$/;

        let value = control.value;//取得输入框的值
        if (value === null || value === "" || value === undefined) { //为空时不验证
            return null
        }
        switch (this.type) {
            case "chinese":
                return reg1.test(value) ? null : { validatorCode: "false" }
            case "english":
                return reg2.test(value) ? null : { validatorCode: "false" }
            case "number":
                return reg3.test(value) ? null : { validatorCode: "false" }
            case "number1":
                return reg4.test(value) ? null : { validatorCode: "false" }
            case "english1":
                return reg5.test(value) ? null : { validatorCode: "false" }
            case "english2":
                return reg6.test(value) ? null : { validatorCode: "false" }
            case "english3":
                return reg7.test(value) ? null : { validatorCode: "false" }
            case "attr":
                return reg8.test(value) ? null : { validatorCode: "false" }
            case "enOrCh":
                return reg9.test(value) ? null : { validatorCode: "false" }
            case "enOrCh1":
                return reg10.test(value) ? null : { validatorCode: "false" }
        }
    }

}
